import { getProdStore } from './store.prod';
import { getDevStore } from './store.dev';

const store = process.env.NODE_ENV === 'production' ? getProdStore() : getDevStore();

export default store as any;
